var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStreetview = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4969 10.305C11.3525 10.4706 11.1912 10.6206 11 10.7316V11.4484C13.0787 11.7403 14.5 12.325 14.5 13C14.5 13.9666 11.59 14.75 8 14.75C4.41 14.75 1.5 13.9666 1.5 13C1.5 12.325 2.92125 11.7406 5 11.4484V10.7316C4.80875 10.6206 4.6475 10.4706 4.50313 10.305C1.83969 10.7919 0 11.8141 0 13C0 14.6569 3.58187 16 8 16C12.4181 16 16 14.6569 16 13C16 11.8141 14.1603 10.7919 11.4969 10.305ZM8 4C9.10469 4 10 3.10469 10 2C10 0.895313 9.10469 0 8 0C6.89531 0 6 0.895313 6 2C6 3.10469 6.89531 4 8 4ZM6 10V13C6 13.5522 6.44781 14 7 14H9C9.55219 14 10 13.5522 10 13V10C10.5522 10 11 9.55219 11 9V6C11 5.17156 10.3284 4.5 9.5 4.5H9.13125C8.78531 4.65719 8.40438 4.75 8 4.75C7.59562 4.75 7.21469 4.65719 6.86875 4.5H6.5C5.67156 4.5 5 5.17156 5 6V9C5 9.55219 5.44781 10 6 10Z",
    fill: "#005E7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStreetview);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/streetview.2d84090abd1a9a2463c9b4634773943b.svg";